/****** wishlist Component ******/
var LOCAL_STORAGE_WISHLIST_KEY = 'WishlistProducts',
    LOCAL_STORAGE_DELIMITER = ',',
    BUTTON_ACTIVE_CLASS = 'active',
    GRID_LOADED_CLASS = 'loaded',
    wishlistSelectors = {button: '[button-wishlist]', grid: '[grid-wishlist]'};

/****** wishlist button events (ajax) ******/
document.addEventListener('initialize:wishlist-button', function () {
    initWishlistButtons();
});

document.addEventListener('trigger:wishlist-button', function (event) {
    updateWishlist(event.detail.handle);
    const buttons = document.querySelectorAll('[button-wishlist][data-product-handle="'+event.detail.selector.dataset.productHandle+'"]');
    buttons.forEach(function(button) {
        if (wishlistContains(event.detail.handle)) {
            button.classList.add(BUTTON_ACTIVE_CLASS);
            button.setAttribute('data-bs-original-title', window.wishlistStrings.remove);
        } else {
            button.classList.remove(BUTTON_ACTIVE_CLASS);
            button.setAttribute('data-bs-original-title', window.wishlistStrings.add);
        }
    });
});

document.addEventListener('DOMContentLoaded', function () {
    initWishlistButtons();
    initWishlistGrid();
    // inite product box style shop-box js
    //CardBox();
});

document.addEventListener('shopify-wishlist:updated', function (event) {
    initWishlistGrid();
    // inite product box style shop-box js
    //CardBox();
});

document.addEventListener('shopify-wishlist:init-product-grid', function (event) {
    // inite product box style shop-box js
    //CardBox();
});

document.addEventListener('shopify-wishlist:init-buttons', function (event) {
    // inite product box style shop-box js
    //CardBox();
});

var setupWishlistGrid = function (grid) {
    var wishlist = getWishlist();
    var requests = wishlist.map(function (handle) {
        if (handle == '') {
            return;
        }
        var productTileTemplateUrl = '/products/' + handle + '?view=card';
        return fetch(productTileTemplateUrl).then(function (res) {
            return res.status === 200 ? res.text() : '';
        });
    });

    Promise.all(requests).then(function (responses) {
      
        var wishlistProductCards = responses.join('');
        console.log('in',grid);
        if (!wishlistProductCards.trim()) {
            wishlistProductCards = '<div class="w-100 text-center wishlist-warning"><h6>You have no items in your wishlist.</h6> <a href="/collections/all" class="btn btn-medium btn-black"><i class="feather-arrow-left left-icon"></i>Back to shopping</a></div>';
        }

        grid.innerHTML = wishlistProductCards;
        grid.classList.add(GRID_LOADED_CLASS);
        initWishlistButtons();
        //window.initVariantChanger(document.querySelector('[grid-wishlist]'));

        var event = new CustomEvent('shopify-wishlist:init-product-grid', {
            detail: { wishlist: wishlist }
        });
        let tooltipTriggerList = grid.querySelectorAll('[data-bs-toggle="tooltip"]');
        //window.initTooltips(tooltipTriggerList); 
        document.dispatchEvent(event);
    });
};

var setupWishlistButtons = function (buttons) {
    buttons.forEach(function (button) {
        var addedText = button.dataset.textAdded;
        var productHandle = button.dataset.productHandle || false;
        if (!productHandle) return console.error('[Hongo Wishlist] Missing `data-product-handle` attribute. Failed to update the wishlist.');
        if (wishlistContains(productHandle)) { 
            button.classList.add(BUTTON_ACTIVE_CLASS);
            button.setAttribute('data-bs-original-title', window.wishlistStrings.remove);
        }  
    });
};

var initWishlistGrid = function (element) {
    var grid = document.querySelector(wishlistSelectors.grid) || false;
    if (grid) setupWishlistGrid(grid);
    //document.querySelector(element).tooltip('dispose');
};

var initWishlistButtons = function () {
    //console.log('inwishinit');
    var wishlist_selectors = document.querySelectorAll('[data-wishlist-counter]');
    var wishlist = getWishlist();
    var wishlist_count = wishlist.length;
    var add_count = document.querySelector(".cart-bubble");
    wishlist_selectors.forEach (function (wishlist_selector) {
        if( wishlist_selector != null  && wishlist_selector != '' ){
        
            if( wishlist_count <= 0 ){ 
                wishlist_selector.classList.add("d-none");
                add_count.classList.add("no-count");
            }
            else{
                add_count.classList.remove("no-count");
                wishlist_selector.classList.remove("d-none");
            }
            //wishlist_selector.innerHTML = wishlist_count;
        }
    });    
    var buttons = document.querySelectorAll(wishlistSelectors.button) || [];
    if (buttons.length) setupWishlistButtons(buttons);
    else return;
    var event = new CustomEvent('shopify-wishlist:init-buttons', {
        detail: { wishlist: getWishlist() }
    });
    document.dispatchEvent(event);
};
var wishlistContains = function (handle) {
    var wishlist = getWishlist();
    return wishlist.indexOf(handle) !== -1;
};
var getWishlist = function () {
    var wishlist = localStorage.getItem(LOCAL_STORAGE_WISHLIST_KEY) || false;
    if (wishlist) return wishlist.split(LOCAL_STORAGE_DELIMITER);
    return [];
};
var setWishlist = function (array) {
    var wishlist = array.join(LOCAL_STORAGE_DELIMITER);
    if (array.length) localStorage.setItem(LOCAL_STORAGE_WISHLIST_KEY, wishlist);
    else localStorage.removeItem(LOCAL_STORAGE_WISHLIST_KEY);

    var event = new CustomEvent('shopify-wishlist:updated', {
        detail: { wishlist: array }
    });
    document.dispatchEvent(event);

    return wishlist;
};
var updateWishlist = function (handle) {
    var wishlist = getWishlist();
    var indexInWishlist = wishlist.indexOf(handle);
    if (indexInWishlist === -1) wishlist.push(handle);
    else wishlist.splice(indexInWishlist, 1);
    var wishlist_selectors = document.querySelectorAll('[data-wishlist-counter]');
    var add_count = document.querySelector(".cart-bubble");
    wishlist_selectors.forEach ( function (wishlist_selector) {
        if( wishlist_selector != null  && wishlist_selector != '' ){
            var wishlist_count = wishlist.length;
            if( wishlist_count <= 0 ){ 
                wishlist_selector.classList.add("d-none");
                add_count.classList.add("no-count");;
            }
            else{
                wishlist_selector.classList.remove("d-none");
                add_count.classList.remove("no-count");;
            }
        
            //wishlist_selector.innerHTML = wishlist_count;
        } 
    });
    return setWishlist(wishlist);
};
var resetWishlist = function () {
    return setWishlist([]);
};

/****** Add to wishlist ******/
var triggerWishButton = function (wishlist_btn) {
  var handle = wishlist_btn.getAttribute('data-product-handle');
  var wishlistEvent = new CustomEvent("trigger:wishlist-button", {
      detail: { 
          handle: handle,
          selector: wishlist_btn,
          addText: wishlist_btn.getAttribute('data-text-add'),
          addedText: wishlist_btn.getAttribute('data-text-added')
      }
  });
  document.dispatchEvent(wishlistEvent);
}